import * as React from "react";
const SvgFiRrCloudsSun = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-clouds-sun_svg__a)">
      <path
        fill="#062147"
        d="M2.778 15.513a1.284 1.284 0 0 0-.73 1.543 1 1 0 1 1-1.933.51 3.285 3.285 0 0 1 1.874-3.891 5.3 5.3 0 0 1 .039-2.441 5.534 5.534 0 0 1 7.606-3.769 1 1 0 0 1-.8 1.832A3.6 3.6 0 0 0 6.86 9.04a3.58 3.58 0 0 0-2.917 4.269 1.964 1.964 0 0 1-1.165 2.204m17.1 4.9a4.62 4.62 0 0 1-3.453 3.445 5 5 0 0 1-.992.123c-1.381.027-7.8.036-9.236 0a3.5 3.5 0 0 1-.781-.113 3.285 3.285 0 0 1-.424-6.188 5.3 5.3 0 0 1 .039-2.441 5.548 5.548 0 0 1 10.524-.794c.078.187.407.263.737.323q.164.03.268.056a4.67 4.67 0 0 1 3.315 5.585zm-3.834-3.657a2.95 2.95 0 0 1-2.336-1.543A3.59 3.59 0 0 0 9.86 13.04a3.58 3.58 0 0 0-2.917 4.269 1.964 1.964 0 0 1-1.165 2.2 1.284 1.284 0 0 0-.73 1.543 1.26 1.26 0 0 0 1.2.921c1.214.033 7.672.028 9.145 0q.295-.007.584-.073a2.64 2.64 0 0 0 1.949-1.943 2.68 2.68 0 0 0-1.885-3.205zM23 9h-2.581a4 4 0 0 0-.048-.31 6 6 0 0 0-.324-1.09l2.225-1.313a1.001 1.001 0 1 0-1.017-1.722l-2.24 1.323a6.7 6.7 0 0 0-.943-.914l1.3-2.262a.999.999 0 1 0-1.732-1l-1.3 2.258A6.7 6.7 0 0 0 15 3.6V1a1 1 0 1 0-2 0v2.564l-.048.007c-.432.06-.854.174-1.257.338l-1.415-2.2A1 1 0 0 0 8.6 2.786l1.527 2.378a1.75 1.75 0 0 0 2.21.648c.287-.132.592-.22.905-.261a4.594 4.594 0 0 1 5.169 3.526 6.25 6.25 0 0 1-.293 2.681 1.894 1.894 0 0 0 .836 2.249l2.358 1.361a1 1 0 0 0 1-1.733l-2.274-1.312q.206-.65.31-1.323H23a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-clouds-sun_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudsSun;
